import { useLocation } from 'react-router-dom';

export function useLocationState<T extends any>() {
  const { state } = useLocation();
  return state as T;
}
